// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="cancelPaymentHeader" id="dialogTitle">Username</h1>
        </div>
        <div class="hoa-dialog__main">
            <p tid="cancelPaymentBody">For your security, your Login ID is not editable.</p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button tid="cancelPaymentYes" id="yesButton" class="Button Button--blue Button--minWidth130"
                    (click)="closeDialog('cancel')">Close
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;